import React from "react";
import "./terms.css";
import { year } from "../../utility/emailAuthorizations";

const data = {
  title: "Personal Data Collected From Users",
  sections: [
    {
      heading: "Social Media Pages",
      content:
        "We have pages on social media sites like LinkedIn, Facebook, and Twitter. When you interact with our Social Media Pages, we will collect Personal Data that you elect to provide us through your settings on the Social Media Site, such as your contact details. In addition, the companies that host our Social Media Pages may provide us with aggregate information and analytics regarding the use of our Social Media Pages.",
    },
    {
      heading: "Use of the Site",
      content:
        "When you visit, use, and interact with the Site, You agree and consent that we may receive certain information about your visit, use, or interactions. For example, we may monitor the number of people that visit our Site, peak hours of visits, which page(s) are visited on our Site, the domains our visitors come from, and which browsers people use to access and visit our Site.",
    },
    {
      heading: "Log Data",
      content:
        "Information ('log data') that your browser automatically sends whenever you visit the Site. Log data includes your Internet Protocol ('IP') address, browser type and settings, and how you interacted with the Site.",
    },
    {
      heading: "Cookies",
      content:
        "Please see the 'Cookies' section below to learn more about how we use cookies.",
    },
    {
      heading: "Device Information",
      content:
        "Includes the name of the device, operating system, and browser you are using. Information collected may depend on the type of device you use and its settings.",
    },
    {
      heading: "Usage Information",
      content: `We collect information about how You use Our Site, such as the types of content that you view or engage with, the features you use, the actions you take, and the time, frequency, and duration of your activities.

In case You choose the option of scheduling a demo of any of the Services offered by BeFiSc, You will be asked to provide information pertaining to Your name, email address, the exact Service that You require a demo of, and any other information that you may willingly choose to share with BeFiSc. BeFiSc shall use, store and process such information in accordance with the terms of this Privacy Policy.`,
    },
    {
      heading: "Personal Data Collected on Behalf of Users",
      content:
        "We also collect Personal Data from individuals in the course of providing Services to our clients. We have no direct relationship with the individuals whose Personal Data we process on behalf of our clients– we process their Personal Data pursuant to our Terms of Service and other agreements with our Users. If you are such an individual and would no longer like your Personal Data to be used by one of our clients or you would like to access, correct, or request deletion of your Personal Data, please contact the client that you interact with directly.",
    },
  ],
};
const personalDataList = [
  "To respond to inquiries, comments, feedback, or questions",
  "To manage our relationship with our Users, which includes sending administrative information relating to our Service and changes to our terms, conditions, and policies, and asking Users to leave a review or take a survey",
  "To analyze how you interact with our Service and provide, maintain and improve the content and functionality of the Service and our customer relationships and experiences, develop our business and inform our marketing strategy",
  "To administer and protect our business and the Site, prevent fraud, criminal activity, or misuse of our Site, and ensure the security of our IT systems, architecture, and networks (including troubleshooting, testing, system maintenance, support, and hosting of data) ",
  "BeFiSc may access, preserve and disclose any User Data and Personal Information in order to (i) comply with law enforcement or national security requests (ii) protect Your’, BeFiSc’s, or others’ rights, property, or safety; (iii) enforce BeFiSc’s policies or contracts; (iv) to prevent physical harm or financial loss or in connection with an investigation or prosecution of suspected or actual illegal activity; (v) to carry out actions that BeFiSc believes to be necessary or advisable; (vi) help detect and prevent potentially illegal acts, comply with law enforcement or national security requests and legal processes, such as a court order or subpoena. In addition, from time to time, server logs may be reviewed for security purposes to detect unauthorized activity on the Services. In such cases, server log data containing IP addresses may be shared with law enforcement bodies in order that they may identify Users in connection with their investigation of the unauthorized activities.",
];
const userObligation = [
  "You must, at all times, adhere to this Privacy Policy. This includes not misusing all intellectual property rights which may belong to the BeFiSc’s third parties.",
  "You must not create or otherwise disseminate any information which may be deemed to be injurious, violent, offensive, racist or xenophobic or which may otherwise violate the purpose and spirit of BeFiSc and its community of Users.",
  "You must not provide information to BeFiSc and /or other Users which You believe might be injurious or detrimental to Your person, professional or social status.",
  "Any violation of this Privacy Policy may lead to the restriction, suspension or termination of Your account and/or Services by BeFiSc, as we take these principles seriously and consider them to be the basis on which our Users and clients adhere to BeFiSc’s policies and the Services which it offers.",
  "You hereby warrant and represent that You are duly authorized to submit or represent the third party on behalf of whom You are providing these information to BeFiSc. Further, You acknowledge and agree that these materials, suggestions, feedback and information can be utilized without any obligation or restriction on BeFiSc in terms of payment of fee or any other limitations for marketing, promoting, advertising or other purposes.",
];
const userRight = [
  "Withdraw Your consent to the processing of Personal Data and User Data by BeFiSc without affecting the lawfulness of processing based on consent before its withdrawal. You also have the right to request us to rectify any inaccurate Personal Information.",
  "Request BeFiSc to erase Your Personal Information and/or restrict the processing of your Personal Information in certain circumstances.",
];
const QuestionsList = [
  {
    question: "Data Retention",
    answer:
      "We keep Personal Data for as long as reasonably necessary for the purposes described in this Privacy Policy, while we have a legitimate business need to do so, or as required by law (e g for tax, legal, accounting or other purposes), whichever is the longer.If you have elected to receive marketing communications from us, we retain information about your marketing preferences until you opt-out of receiving these communications and in accordance with our policies.To determine the appropriate retention period for your Personal Data, we will consider the amount, nature, and sensitivity of the Personal Data, the potential risk of harm from unauthorised use or disclosure of your Personal Data, the purposes for which we use your Personal Data and whether we can achieve those purposes through other means, and the applicable legal requirements.",
  },
  {
    question: "Update Your Information",
    answer:
      "You may contact us if you need to change or correct your Personal Data or wish to have it deleted from our systems. We will address your request as required by applicable law.",
  },
  {
    question: "Online Tracking",
    answer:
      "We may, and we may allow third-party service providers to, use cookies or other tracking technologies to collect information about your browsing activities over time and across different websites following your use of the Site. ",
  },
  {
    question: "Data Integrity and Purpose Limitation",
    answer:
      "We take reasonable steps to ensure that Personal Data is reliable for its intended use and that it is accurate, complete, and current for as long as we retain it. We will retain the data as long as necessary for the following purposes: delivering the Services, engaging in customer service, complying with legal obligations, auditing, performing security and fraud prevention, responding to legal and regulatory inquiries, and preserving or defending our legal rights or those of other users or third parties. ",
  },
  {
    question: "Links to Other Websites",
    answer:
      "The Service may contain links to other websites not operated or controlled by BeFiSc, including social media services (“Third Party Sites”). The information that you share with Third Party Sites will be governed by the specific privacy policies and terms of Service of the Third Party Sites and not by this Privacy Policy. By providing these links we do not imply that we endorse or have reviewed these sites. Please contact the Third Party Sites directly for information on their privacy practices and policies",
  },
  {
    question: "Cookies",
    answer:
      "We and our partners use cookies to operate and administer our Site, make it easier for you to use the Site during future visits, and gather usage data on our Site. Upon navigation of our website and/or Services, certain passive information may also be collected about your visit, including through cookies and similar technologies",
  },
  {
    question: "Security",
    answer:
      "You use the Service at your own risk. We comply with industry standards to protect Personal Data both online and offline from loss, misuse, and unauthorized access, disclosure, alteration or destruction. However, no Internet or email transmission is ever fully secure or error-free. In particular, email sent to or from us may not be secure. Therefore, you should take special care in deciding what information you send to us via the Service or email. Please keep this in mind when disclosing any Personal Data to BeFiSc via the Internet. In addition, we are not responsible for circumvention of any privacy settings or security measures contained on the Service, or third-party websites. Unfortunately, the Internet cannot be guaranteed to be 100% (hundred percent) secure, and we cannot ensure or warrant the security of any information you provide to us. We do not accept liability for unintentional disclosure. ",
  },
  {
    question: "Your Choices",
    answer:
      "Whether or not you provide Personal Data to us is completely up to you, but if you choose not to provide information that is needed to use some features of our Site, you may be unable to use those features. You can also contact us to request access to your data or to ask us to update, correct, or delete your Personal Data ",
  },
  {
    question: "Changes to Privacy Policy",
    answer:
      "The Service, and our business may change from time to time. As a result, we may change this Privacy Policy at any time. When we do we will post an updated version on this page, unless another type of notice is required by the applicable law. By continuing to use our Service or providing us with Personal Data after we have posted an updated Privacy Policy, or notified you if applicable, you consent to the revised Privacy Policy and practices described in it. ",
  },
  {
    question: "Contact Us",
    answer:
      "If you have any questions or grievances about our Privacy Policy or the information practices of the Site, please feel free to contact us at support@befisc.com We will address your concerns and attempt to resolve any privacy issues in a timely manner.",
  },
];

function Terms() {
  return (
    <div className="terms-main">
      <div className="terms-headings-contanier">
        <div className="terms-headings">
          <span>Privacy </span>
          <span>Policy</span>
        </div>
        <p>Last updated: February 26, {year}</p>
      </div>

      <div className="privacy-policy-container">
        {/* left pillar */}
        <div
          className="pillar pillar-left"
          style={{
            flex: "0 0 7%",
            background: "url('/images/pillars.svg') no-repeat top",
            backgroundSize: "contain",
            height: "auto",
          }}
        ></div>
        <div className="content">
          <div className="terms-grid-view">
            {/* main content */}
            <div className="text-content">
              <p>
                Welcome to the website (the “Site”) of BeFiSc Private Limited.
                Including all its subsidiaries/affiliates having its office at
                Gautam Buddha Nagar, UP-201306 (collectively called “BeFiSc,”
                “we,” “us,” or “our”). BeFiSc allows its business customers to
                secure their user journey by means of identity verification,
                authentication services, fraud prevention, risk assessments,
                transaction monitoring, payment processing, etc., (collectively,
                including the Site, the “Service” or “Services”).
                <br />
                <br /> This privacy policy (“Privacy Policy”) details the manner
                in which personal data consisting of names, birthdates,
                addresses, phone numbers, email addresses, government
                identification numbers and copies of government identification
                documents, face photos, IP addresses, browser fingerprints,
                cookie, and device identifiers, and location data and other such
                data as may be applicable (“Personal Data”) is collected used
                and shared BeFiSc’s data practices. This Privacy Policy
                constitutes a legal and binding agreement (“Agreement”) between
                You (hereinafter referred to as “You,” or “Your” or “User(s)”
                and BeFiSc, and provides, inter alia, the terms that govern the
                usage of the Personal Data in order to provide access to
                BeFiSc’s Website and respective Services.
                <br />
                <br /> This Privacy Policy describes BeFiSc’s policies and
                procedures on the collection and procedures on the collection,
                use, and disclosure of the information provided by the visitors
                to the Site. BeFiSc shall not use the User’s information (“User
                Data”) in any manner except as provided under this Privacy
                Policy. Every User who accesses the Site agrees to be bound by
                the terms of this Privacy Policy.
              </p>
              <p className="services-heading">
                Please read this Privacy Policy before using our Service and/ or
                submitting any Personal Data to BeFiSc.
              </p>

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">Personal Data Collected From Users</span>
                </div>
                <div className="a-tab">
                  <span className="simple-text">
                    By using our services and the Website, You hereby agree and
                    consent that in order for BeFiSc to provide services and/or
                    access to the Website, BeFiSc will collect Personal Data
                    from you and other individuals in the course of verifying
                    their identities, monitoring and facilitating transactions,
                    and/or preventing fraud for our Users. This Personal Data
                    includes names, birthdates, addresses, phone numbers, email
                    addresses, government identification numbers and copies of
                    government identification documents, face photos, IP
                    addresses, browser fingerprints, cookie and device
                    identifiers, and location data. We may also collect scans of
                    facial geometry
                  </span>
                  <ContentSection sections={data.sections} />
                </div>
              </div>
              {/* section two */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />
                  <span className="q">How We Use Personal Data?</span>
                </div>
                <div className="a-tab">
                  <span className="simple-text">
                    We use Personal Data to provide our clients with the
                    Services. This processing is necessary to perform our
                    contract with our Users.
                  </span>
                  <br />
                  <br />
                  <span className="simple-text">
                    We also use Personal Data as necessary for the following
                    legitimate business interests:
                  </span>
                  <ul
                    style={{
                      position: "relative",
                      right: "1.5rem",
                      display: "flex",
                      flexDirection: "column",
                      gap: ".2rem",
                    }}
                  >
                    {personalDataList &&
                      personalDataList.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                  <ContentSection
                    sections={[
                      {
                        heading: "Marketing",
                        content:
                          "We may contact You to provide the information we believe will interest you. For instance, if you elect to provide your email address, we may use that information to send You promotional information about Our products and services. You may opt out of receiving emails by following the instructions contained in each promotional email we send You or by contacting Us. If You unsubscribe from our marketing lists, You will no longer receive marketing communications. Still, we will continue contacting you regarding our Site and Services and responding to your requests.",
                      },
                    ]}
                  />
                </div>
              </div>
              {/* section three */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">User Obligations</span>
                </div>

                <ul
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: ".2rem",
                  }}
                >
                  {userObligation &&
                    userObligation.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                </ul>
              </div>
              {/* section four */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem ",
                  justifyContent: "start",
                  marginTop: "2rem",
                }}
              >
                <div className="q-tab">
                  <img
                    src={"/images/question-close-icon.png"}
                    alt=""
                    className="q-tab-icon"
                    loading="lazy"
                    decoding="async"
                  />

                  <span className="q">User Rights</span>
                </div>
                <span className="a-tab simple-text">
                  Where permitted by applicable laws, You have the right to
                  <ul
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: ".2rem",
                    }}
                  >
                    {userRight &&
                      userRight.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                  </ul>
                </span>
              </div>
              {/* section five */}
              <div className="tabs-view">
                {QuestionsList &&
                  QuestionsList.map((item, index) => (
                    <QuestionsTab
                      ques={item.question}
                      ans={item.answer}
                      state={true}
                    />
                  ))}
              </div>
            </div>
          </div>
        </div>
        {/* right pillar */}
        <div
          className="pillar pillar-left"
          style={{
            flex: "0 0 7%",
            background: "url('/images/pillars.svg') no-repeat top",
            backgroundSize: "contain",
            height: "auto",
          }}
        ></div>
      </div>
    </div>
  );
}

export default Terms;

const ContentSection = ({ sections }) => {
  return (
    <>
      {sections.map((section, index) => (
        <div key={index} className="section-item">
          <h3 className="section-title">{section.heading}</h3>
          <p className="section-content">{section.content}</p>
        </div>
      ))}
    </>
  );
};
function QuestionsTab({ ques, ans }) {
  return (
    <div className="flexprop" style={{ gap: "20px" }}>
      <div className="q-tab">
        <img
          src={"/images/question-close-icon.png"}
          alt=""
          className={`q-tab-icon }`}
          loading="lazy"
          decoding="async"
        />

        <span className="q">{ques}</span>
      </div>
      <div className="a-tab">{ans}</div>
    </div>
  );
}
